import { render, staticRenderFns } from "./iconCurrent.vue?vue&type=template&id=6b804592&"
import script from "./iconCurrent.vue?vue&type=script&lang=js&"
export * from "./iconCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports